import classNames from 'classnames'
import * as React from 'react'

import {stringifyId} from '../../../../../types'
import {resolveRelative} from '../../../../../utils/url'
import Link from '../../../../common/Link/Link'

import type {Props} from './ViewThreadDumpButton.types'

import styles from './ViewThreadDumpButton.css'

function ViewThreadDumpButton({agentId, projectId, className}: Props) {
  return (
    <Link
      href={resolveRelative(
        `/stacktraces/stacktrace.html?agentId=${stringifyId(agentId)}&projectId=${stringifyId(
          projectId,
        )}`,
      )}
      className={classNames(className, styles.link)}
      target="_blank"
      rel="noreferrer"
    >
      {'View thread dump'}
    </Link>
  )
}

export default React.memo<Props>(ViewThreadDumpButton)
